var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button-group',{staticClass:"mx-1",attrs:{"size":"sm"}},[_c('b-button',{attrs:{"variant":"secondary"},on:{"click":function($event){$event.preventDefault();return _vm.remove.apply(null, arguments)}}},[_c('i',{staticClass:"las la-trash"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }